import getMessage from 'src/background/utils/i18n.utils';
import { WitnessInfoDataComponent } from '@popup/steem/pages/app-container/home/governance/my-witness-tab/witness-information/witness-info-data/witness-info-data.component';
import React from 'react';
import { connect } from 'react-redux';
import 'react-tabs/style/react-tabs.scss';
const WitnessInformationParameters = ({ witnessInfo, }) => {
    return (React.createElement("div", { className: "witness-information-parameters" },
        React.createElement("div", { className: "label-title" }, getMessage('popup_html_witness_information_signing_key_label')),
        React.createElement("div", { className: "smaller-text" }, witnessInfo.signingKey),
        React.createElement("div", { className: "info-panel" },
            React.createElement(WitnessInfoDataComponent, { label: 'popup_html_witness_information_maximum_block_size_label', value: witnessInfo.params.maximumBlockSize }),
            React.createElement(WitnessInfoDataComponent, { label: 'popup_html_witness_information_account_creation_fee_label', value: witnessInfo.params.accountCreationFeeFormatted }),
            React.createElement(WitnessInfoDataComponent, { label: 'popup_html_witness_information_hbd_interest_rate_label', value: `${witnessInfo.params.sbdInterestRate.toFixed(2)}%` }))));
};
const mapStateToProps = (state) => {
    return {
        activeAccount: state.steem.activeAccount,
        currencyPrices: state.steem.currencyPrices,
    };
};
const connector = connect(mapStateToProps, {});
export const WitnessInformationParametersComponent = connector(WitnessInformationParameters);
